import { render, staticRenderFns } from "./commandeclient_list.vue?vue&type=template&id=5f787686&"
import script from "./commandeclient_list.vue?vue&type=script&lang=js&"
export * from "./commandeclient_list.vue?vue&type=script&lang=js&"
import style0 from "./commandeclient_list.vue?vue&type=style&index=0&id=5f787686&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports